module.exports = __webpack_public_path__ + "img/open_door.301835cb.png";